<template>
    <el-popover :placement="!is_add ? 'left-end' : 'right-end'"
                width="400" trigger="click" v-model="show"
                popper-class="child_popover add_payment_popover"
                @show="open">
        <div class="add_pay_popover" v-if="show">
            <div class="pay_content">
                <addPay :detail="form" ref="add_pay" :other_pay_type="other_pay_type"
                        :is_add="is_add"
                        @change="payChange"></addPay>
            </div>
            <div class="button">
                <el-button class="button_78px" size="mini" type="primary" :disabled="disabled"
                           @click="submitForm">{{ detail?.status == 3 ? '重新发起' : '保存' }}
                </el-button>
            </div>
        </div>
        <el-button slot="reference" type="text" size="small" v-if="is_add">
            <span class="icon el-icon-plus" style="margin-right: 5px"></span>
            <span>添加付款进度</span>
        </el-button>
        <div slot="reference" class="edit btn" v-else>
            <span class="icon el-icon-edit"></span>
        </div>
    </el-popover>
</template>

<script setup>
import {computed, ref, nextTick} from 'vue';
import addPay from '../add_pay/index.vue';
import computedData from "@/mixins/computedData";
import api from "@/api/methods";
import {Message} from "element-ui";

const add_pay = ref(null);

const props = defineProps({
    //合同详情
    contract_detail: {
        type: Object,
        default: () => {
            return {};
        }
    },
    //付款进度列表
    pay_list: {
        type: Array,
        default: () => {
            return [];
        }
    },
    //付款进度详情
    detail: {
        type: Object,
        default: () => {
            return {};
        }
    },
});

const emits = defineEmits(['change']);

let show = ref(false);
let default_form = ref({
    pay_type: '',
    pay_time: '',
    psy_money: undefined,
});
let form = ref({});
let disabled = ref(false);

const showMoney = computed(() => (e) => {
    return computedData.computed.showMoney()(e);
});
const other_pay_type = computed(() => {
    let arr = JSON.parse(JSON.stringify(props.pay_list));
    let index = arr.findIndex(a => a.id == props.detail.id);
    arr.splice(index, 1);
    return arr.filter(a => a.pay_type).map(a => a.pay_type);
});
const is_add = computed(() => {
    return !props.detail?.id || props.detail?.id === 'add';
});
const checkMoney = computed(() => (money, list) => {
    return computedData.computed.checkMoney()(money, list);
});
//是否修改过
const is_change = computed(() => {
    if (is_add.value) {
        return true;
    }
    let props_detail = props.detail;
    let current_detail = form.value;
    let pay_type_change = props_detail.pay_type != current_detail.pay_type;
    let pay_time_change = props_detail.pay_time != current_detail.pay_time;
    let current_psy_money = current_detail.psy_money
    if (current_psy_money) {
        current_psy_money = Number(current_psy_money) * 10000;
    }
    let money_change = props_detail.psy_money != current_psy_money;
    return pay_type_change || pay_time_change || money_change;
});

//付款进度变更
function payChange(val) {
    form.value.pay_type = val.pay_type;
    form.value.pay_time = val.pay_time;
    form.value.psy_money = val.psy_money;
}

//保存
async function submitForm() {
    if (disabled.value) {
        return;
    }
    //必填验证
    let check = false;
    if (add_pay.value) {
        check = await add_pay.value.checkForm();
    }
    //金额验证
    let psy_money = 0;
    if (form.value.psy_money) {
        psy_money = Number(form.value.psy_money) * 10000;
    }
    let arr = props.pay_list?.length ? JSON.parse(JSON.stringify(props.pay_list)) : [];
    if (!is_add.value) {
        let index = arr.findIndex(a => a.id == props.detail?.id);
        arr.splice(index, 1, {
            ...form.value,
            psy_money
        });
    } else {
        arr.push({
            ...form.value,
            psy_money
        });
    }
    let check_money = checkMoney.value(props.contract_detail?.money, arr);
    if (!check || !check_money) {
        if (!check_money) {
            Message({message: '付款金额总数不能超过合同金额!', type: 'warning'});
        }
        return;
    }
    if (is_change.value) {
        disabled.vaule = true;
        let param = {
            project_id: props.contract_detail?.project_id,
            contract_id: props.contract_detail?.id,
            pay_type: form.value.pay_type,
            pay_time: form.value.pay_time,
            psy_money
        };
        if (!is_add.value) {
            param.id = props.detail.id;
        }
        let res = await api.contract.SaveContractPay(param);
        if (res?.data?.state == 1) {
            if (props.detail?.status != 3) {//修改,新增
                Message({message: '保存成功!', type: 'success'});
            } else {//重新发起审批
                let res2 = await api.contract.PayStatusChange({
                    id: props.detail?.id,
                    project_id: props.contract_detail?.project_id,
                    contract_id: props.contract_detail?.id,
                    status: 1,
                });
                if (res2?.data?.state == 1) {
                    Message({message: '重新发起成功!', type: 'success'});
                }
            }
        }
        emits('change');
    } else {
        if (props.detail?.status != 3) {
            Message({message: '保存成功!', type: 'success'});
        } else {
            Message({message: '未修改内容!', type: 'warning'});
        }
    }
    show.value = false;
    disabled.value = false;
}

/**
 * 初始化
 */
function open() {
    disabled.value = false;
    form.value = JSON.parse(JSON.stringify(default_form.value));
    if (!is_add.value) {
        form.value = {
            ...props.detail,
            psy_money: showMoney.value(props.detail.psy_money),
        };
    }
}
</script>

<style scoped lang="less">
.add_pay_popover {
    .pay_content {
        padding: 15px 20px 0 20px;
    }

    .button {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 43px;
        border-top: 1px solid #eee;
    }
}
</style>